export default "__VITE_ASSET__Bga1SKIC__"